/*
 * @Description: 数组里面只有一个数据的伪代码实现方法
 * @Author: shenah
 * @Date: 2023-04-11 17:06:12
 * @LastEditors: shenah
 * @LastEditTime: 2023-08-14 09:34:44
 */
export default {
  /**
   * @description: 替换数据
   * @param {*} obj
   * @return {*}
   */
  replaceDataEvent(obj) {
    if (typeof obj === "number" || typeof obj === "string") {
      this.data = [obj];
      this.extraSpecialRender(obj);
    } else if (Array.isArray(obj)) {
      this.extraSpecialRender(obj);
    } else if (obj && typeof obj === "object") {
      let field = this.mapRelations[0].map;
      if (field) {
        this.data = [obj[field]];
        this.extraSpecialRender(obj);
      }
    }
  },
};
